import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/VideoSection.css';

function VideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);

  // Remplacez par l'ID de votre playlist YouTube
  const PLAYLIST_ID = 'PLT0_3jl_6IHe_vty4IxtWun2g_s0JkzVw'; // À remplacer

  const handlePlayClick = () => {
    setIsPlaying(true);
    // Empêcher le scroll du body quand le lecteur est activé
    document.body.style.overflow = 'hidden';
  };

  const closePlayer = () => {
    setIsPlaying(false);
    // Réactiver le scroll du body
    document.body.style.overflow = 'unset';
  };

  return (
    <section className="video-section">
      <div className="container">
        <h2 className="video-title">شهادات</h2>

        <div className="playlist-container">
          <div className="playlist-preview">
            {/* Image de preview de la playlist */}
            <div className="playlist-thumbnail" onClick={handlePlayClick}>
              <img
                src="/images/tumb.jpg"
                alt="Aperçu de la playlist"
              />
              <div className="play-button-large">
                <div className="play-icon"></div>
              </div>
              <div className="playlist-overlay">
                <div className="playlist-info">
                  <span className="playlist-badge">PLAYLIST</span>
                  <h3 className="playlist-title">شهادات ضحايا العنف الرقمي</h3>
                  <p className="playlist-description">
                    مجموعة من الشهادات الحقيقية لأشخاص تعرضوا للعنف الرقمي وكيف تجاوزوا محنتهم
                  </p>
                </div>
              </div>
            </div>

            {/* Liste des vidéos de la playlist */}
            <div className="playlist-videos-list">
              <div className="playlist-header">
                <h4>محتوى القائمة</h4>
              </div>
              <div className="video-items">
                <div className="video-item" onClick={handlePlayClick}>
                  <div className="item-thumbnail">
                    <img src="/images/tumb.jpg" alt="Vidéo 1" />
                    <div className="item-play-icon"></div>
                  </div>
                  <div className="item-info">
                    <h5>شهادة ضحية عنف رقمي</h5>
                    <p>قصة حقيقية لامرأة تعرضت للابتزاز الإلكتروني</p>
                  </div>
                </div>

                <div className="video-item" onClick={handlePlayClick}>
                  <div className="item-thumbnail">
                    <img src="/images/all.jpg" alt="Vidéo 2" />
                    <div className="item-play-icon"></div>
                  </div>
                  <div className="item-info">
                    <h5>"أنا سارة صحفية (…)" - شهادة 1</h5>
                    <p>سلسلة شهادات مستوحاة من وقائع مرصودة، بالفضاء الرقمي وخارجه</p>
                  </div>
                </div>

                <div className="video-item" onClick={handlePlayClick}>
                  <div className="item-thumbnail">
                    <img src="/images/all.jpg" alt="Vidéo 2" />
                    <div className="item-play-icon"></div>
                  </div>
                  <div className="item-info">
                    <h5>هاجر، صديقة ضحية انتحار - شهادة 2</h5>
                    <p>سلسلة شهادات مستوحاة من وقائع مرصودة، بالفضاء الرقمي وخارجه</p>
                  </div>
                </div>




                <div className="video-item more-videos" onClick={handlePlayClick}>
                  <div className="more-indicator">
                    <span>+16</span>
                    <p>المزيد من الشهادات</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="video-cta-container">

        <Link to="/videos" className="cta-button">
   شاهد جميع الشهادات
</Link>
        </div>
      </div>

      {/* Modal Lecteur Playlist */}
      {isPlaying && (
        <div className="video-modal-overlay" onClick={closePlayer}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="video-modal-close"
              onClick={closePlayer}
              aria-label="Fermer"
            >
              ×
            </button>
            <div className="video-player-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/videoseries?list=${PLAYLIST_ID}&autoplay=1&rel=0`}
                title="Playlist YouTube"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default VideoSection;
